export const style: any = {
  screen_attendance_container: {
    backgroundColor: "white",
    padding: "6px",
    position: "relative",
    marginRight: "10px",
    border: "1px solid #cccfd7",
    height: "60%",
    marginTop: "10%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
};
